const drawText = ({ x = 0, y = 0, fontSize, text, fillStyle, context, fontFamily }) => {
  context.font = `${fontSize}px ${fontFamily}`
  context.fillStyle = fillStyle
  context.textBaseline = 'middle'
  const w = context.measureText(text).width
  context.fillText(text, x - w / 2, y)
}

export default drawText
